import { defineStore } from "pinia";
import { SubApplicationType } from "@/Domain/SubApplicationType";

export const useScheduleAStore = defineStore("scheduleA", {
  state: () => {
    return {
      cartProductsCount: [
        {
          type: SubApplicationType.Add.toString(),
          count: 0,
        },
        {
          type: SubApplicationType.Copy.toString(),
          count: 0,
        },
        {
          type: SubApplicationType.Terminate.toString(),
          count: 0,
        },
      ],
      handleCartCountUpdate: (type: SubApplicationType, count: number) => {},
    };
  },
  actions: {
    getCartCount(type: SubApplicationType) {
      return this.cartProductsCount.find((x) => x.type === type.toString())
        ?.count;
    },
    setCartCount(type: SubApplicationType, count: number) {
      const cart = this.cartProductsCount.find(
        (x) => x.type === type.toString()
      );
      if (!cart) return;
      cart.count = count;
      this.handleCartCountUpdate(type, count);
    },
    addToCartCount(type: SubApplicationType, count: number) {
      const cart = this.cartProductsCount.find(
        (x) => x.type === type.toString()
      );
      if (!cart) return;
      cart.count += count;
      this.handleCartCountUpdate(type, cart.count);
    },
  },
});
